import styled from "styled-components";

export const ImageWrapper = styled.div`
  display: inline-block;
  margin-bottom: 10px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  max-width: 250px;
  height: auto;
  & > img {
    max-height: 100%;
    width: 100%;
    height: auto;
    margin-right: auto;
    margin-left: auto;
    display: block;
    max-width: 100%;
  }
`;
export const FileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
